export default __webpack_public_path__ + "static/media/Stephanie-Zach-1.2257b007.png";